import consumerMdl from './consumer.mdl'

export default [
    ...consumerMdl
]